import React from "react";
import { useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";


const importEmployee = async (input) => {
  const data = await http_payroll.post(
    Api_EndPoints.ImportEmployees,
    input
  );
  return data;
};

export const useImportEmployeesMutation = () => {
  return useMutation({
    mutationFn: importEmployee,
  });
};
